import { useQuery, UseQueryResult } from 'react-query';
import { PackageCategoryRetrieve } from 'types';
import { client } from 'utils/api-client';

function usePackageCategory(
  packageCategoryId: string | undefined,
): UseQueryResult<{ data: PackageCategoryRetrieve }> {
  return useQuery(
    ['packageCategories', packageCategoryId],
    () => client.get(`package-categories/${packageCategoryId}/`),
    {
      enabled: !!packageCategoryId,
    },
  );
}
export default usePackageCategory;
